module.exports = __webpack_public_path__ + "static/media/Billing.c1b26217.png";